/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Swift_Otter_LeapInputs */

const en_keen_swift_otter_leap = /** @type {(inputs: Keen_Swift_Otter_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback approved`)
};

const de_keen_swift_otter_leap = /** @type {(inputs: Keen_Swift_Otter_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback genehmigt`)
};

/**
* | output |
* | --- |
* | "Feedback approved" |
*
* @param {Keen_Swift_Otter_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_swift_otter_leap = /** @type {((inputs?: Keen_Swift_Otter_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Swift_Otter_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_swift_otter_leap(inputs)
	return de_keen_swift_otter_leap(inputs)
});